const MarkerPin03 = ({ size, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "17"}
      height={size || "17"}
      viewBox="0 0 17 17"
      fill="none"
    >
      <g id="marker-pin-03">
        <path
          id="Solid"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.53877 7.04981C2.53877 3.7361 5.22506 1.0498 8.53877 1.0498C11.8525 1.0498 14.5388 3.7361 14.5388 7.04981C14.5388 9.50212 13.165 10.8406 11.8839 11.9152C11.7485 12.0287 11.6156 12.1387 11.486 12.246C10.3391 13.1953 9.44084 13.9388 9.19249 15.1805C9.13017 15.4922 8.85656 15.7165 8.53877 15.7165C8.22098 15.7165 7.94737 15.4922 7.88505 15.1805C7.6367 13.9388 6.73842 13.1953 5.59154 12.246C5.4619 12.1387 5.32908 12.0287 5.19367 11.9152C3.91256 10.8406 2.53877 9.50212 2.53877 7.04981ZM10.5388 7.04981C10.5388 8.15438 9.64334 9.04981 8.53877 9.04981C7.4342 9.04981 6.53877 8.15438 6.53877 7.04981C6.53877 5.94524 7.4342 5.04981 8.53877 5.04981C9.64334 5.04981 10.5388 5.94524 10.5388 7.04981Z"
          fill={color || "#059669"}
        />
      </g>
    </svg>
  );
};

export default MarkerPin03;
